import { createContext } from "solid-js";
const ModalContext = createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide() { },
});
export default ModalContext;
